import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface IConfirmationDialogData {
  title: string;
  message: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
}

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationDialogData,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
  ) {}
}
